import ENV from '../config/environment';

/**
 * This file should contain all relevant url manipulation hepers.
 */

/**
 * Get an absoluate URL to the top level domain based on the environment
 *
 * @param {String} path
 * @return {string}
 */
export function absoluteStoryhunterUrl(path) {
  return `https://${ENV.topLevelDomain}${path}`;
}

/**
 * Get the absolute path to the api subdomain
 *
 * @param {String} path
 * @return {string}
 */
export function absoluteApiUrl(path) {
  return `https://${ENV.apiUrl}${path}`;
}

/**
 * Copy a given link to the clipboard.
 *
 * @param {String} link
 */
export function copyLinkToClipboard(link) {
  const el = document.createElement('textarea');
  el.value = link;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}
